<template>
  <div class="table-error">
    <HelperView
      icon="EF0060"
      type="alert"
      title="Houve um problema ao carregar as movimentações"
      description="Aguarde um momento e tente novamente"
      button-label="Tentar novamente"
      @click="reload"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Emit } from 'vue-property-decorator';
import { HelperView } from '@warrenbrasil/nebraska-web';

@Component({
  components: { HelperView }
})
export default class StatementError extends Vue {
  @Emit('reload')
  reload() {}

  @Emit('load-view')
  loadView() {}

  mounted() {
    this.loadView();
  }
}
</script>

<style lang="less" scoped>
.table-error {
  padding: @size-spacing-x1200 0;
  width: 389px;
  margin: auto;
}
</style>
